// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__whuSD","logo":"Header_logo__1HRlz","content":"Header_content__1J41O","title":"Header_title__3zeu-","background":"Header_background__32EVR"};